module.exports = __webpack_public_path__ + "media/images/samples/300x300/1-ebc878efa96546a10e40987c1a4a2175.jpg";